<template>
  <div class="checkout-payment panel p-4 mb-4">
    <h3 class="text-center text-primary font-weight-bold">
      Pay by Credit Card
    </h3>
    <p class="mb-4 text-center">
      Please enter your billing address and credit card information in the
      fields provided.
    </p>
    <h5 class="font-weight-bold">Payment Method</h5>
    <div class="row">
      <div class="col-12 col-md-5 col-xl-6 mb-3">
        <div class="element">
          <label>Card Number</label>
          <input
            type="text"
            class="form-control"
            name="card_number"
            v-model="cardNumber"
            @keyup="cardNumberInput"
            maxlength="19"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 col-xl-3 mb-3">
        <div class="element">
          <label>Expiration (MM/YYYY)</label>
          <input
            type="text"
            class="form-control"
            name="card_expiration"
            v-model="cardExpiration"
            @keyup="cardExpirationInput"
            maxlength="7"
          />
        </div>
      </div>
      <div class="col-12 col-md-3 mb-3">
        <div class="element">
          <label>Security Code</label>
          <input
            type="text"
            class="form-control"
            name="card_code"
            v-model="cardCode"
            @keyup="cardCodeInput"
            maxlength="4"
          />
        </div>
      </div>
    </div>
    <hr />
    <h5 class="font-weight-bold">Billing Address</h5>
    <div class="row">
      <div class="col-12 mb-3">
        <Field
          type="text"
          name="billing_address1"
          :value="order.payment.billing_address1 || ''"
          label="Address Line 1"
        />
      </div>
      <div class="col-12 mb-3">
        <Field
          type="text"
          name="billing_address2"
          :value="order.payment.billing_address2 || ''"
          label="Address Line 2"
        />
      </div>
      <div class="col-12 col-md-6 mb-3">
        <Field
          type="text"
          name="billing_city"
          :value="order.payment.billing_city || ''"
          label="City"
        />
      </div>
      <div class="col-12 col-md-6 mb-3">
        <StateField
          name="billing_state"
          :value="order.payment.billing_state || ''"
          label="State/Province"
        />
      </div>
      <div class="col-12 col-md-6 mb-3">
        <Field
          type="text"
          name="billing_zip"
          :value="order.payment.billing_zip || ''"
          label="ZIP/Postal Code"
        />
      </div>
      <div class="col-12 col-md-6 mb-3">
        <Field
          type="select"
          name="billing_country"
          :value="order.payment.billing_country || 'US'"
          label="Country"
          :options="countryOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: { type: Object, required: true },
  },
  data() {
    return {
      cardNumber: "",
      cardExpiration: "",
      cardCode: "",
      countryOptions: [
        { value: "US", label: "United States" },
        { value: "CA", label: "Canada" },
      ],
    };
  },
  methods: {
    cardNumberInput() {
      var cardNumber = this.cardNumber;
      this.cardNumber = cardNumber.replace(/[^0-9]*/gi, "").substring(0, 16);
    },
    cardExpirationInput() {
      var cardExpiration = this.cardExpiration;
      cardExpiration = cardExpiration.replace(/[^0-9]*/gi, "").substring(0, 6);
      if (cardExpiration.length > 1) {
        cardExpiration =
          cardExpiration.substring(0, 2) + "/" + cardExpiration.substring(2);
      }
      this.cardExpiration = cardExpiration;
    },
    cardCodeInput() {
      var cardCode = this.cardCode;
      this.cardCode = cardCode.replace(/[^0-9]*/gi, "").substring(0, 4);
    },
  },
};
</script>